import classNames from 'classnames';
import React, { FC, memo, PropsWithChildren, useRef } from 'react';

import { Portal } from '../Portal/Portal';
import { PortalContainerContextProvider } from '../Portal/PortalContainerContext';
import { useCatchFocusInElement } from '../hooks/useCatchFocusInElement/useCatchFocusInElement';
import styles from './FullscreenPopup.styles.m.css';

interface IFullscreenPopupProps {
  className?: string;
}

export const FullscreenPopup: FC<PropsWithChildren<IFullscreenPopupProps>> = memo(
  ({ children, className }) => {
    const rootRef = useRef<HTMLDivElement>(null);
    useCatchFocusInElement(rootRef);

    return (
      <Portal>
        <div
          ref={rootRef}
          className={classNames(styles.popup, className)}
        >
          <PortalContainerContextProvider value={{ portalContainerRef: rootRef }}>
            {children}
          </PortalContainerContextProvider>
        </div>
      </Portal>
    );
  }
);
